import { Collapse } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DUVIDAS } from '../conteudo/duvidas';

export function Duvidas() {
  return (
    <section id="duvidas" className="landing-secao duvidas-grade">
      <div className="secao-abertura">
        <span className="sobretitulo">PODE PERGUNTAR</span>
        <h2>
          Antes do
          <br />
          <em>primeiro acerto.</em>
        </h2>
        <p>O que você precisa saber para começar.</p>
      </div>
      <Collapse
        className="duvidas-lista"
        accordion
        ghost
        expandIconPlacement="end"
        expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 45 : 0} />}
        items={DUVIDAS.map((item, indice) => ({
          key: String(indice),
          label: item.pergunta,
          children: <p>{item.resposta}</p>,
        }))}
      />
    </section>
  );
}
